/**
 * The version of what this app understands in boards' and issues' documents. The server knows
 * the oldest one it still talks to (crates/server/src/collab/mod.rs, MIN_CLIENT_PROTOCOL): when
 * documents gain something an older app would break, it is raised there and here, and tabs left
 * open from before are asked to reload instead of joining.
 */
export const CLIENT_PROTOCOL = 3;

/** The collaboration socket address for a path (`/collab/…`), with the version. */
export function collabUrl(path: string): string {
  const proto = location.protocol === 'https:' ? 'wss' : 'ws';
  return `${proto}://${location.host}${path}${path.includes('?') ? '&' : '?'}v=${CLIENT_PROTOCOL}`;
}

/** The server said this app is too old: the page shows it once. */
export const OUTDATED_EVENT = 'vatman-outdated';
